export default __webpack_public_path__ + "static/media/904.4b4ccb87.png";